import React from 'react'
import { SpecificationsComponent, DescriptionComponent, FooterComponent } from './atoms'
import { ProductDetailDiv, ContainerBackground, StyledClose, HeaderMobile, StyledButton  } from './product-detail.styled.component'
import { Text } from '../'
import { ASSETS_FOLDER } from '../../assets'
import { GrClose } from 'react-icons/gr'
import { useResize } from '../../hooks'
import { store } from '../../effects/store'
import { setMenu } from '../../effects/actions'

const ProductDetailComponent = ({ onClickKnowMore, product, collection }) => {

  const isMobile = useResize().isMobile;
  
  const onClose = () => {
    store.dispatch(setMenu(false))
  }

  return (
    <ContainerBackground image={`${ASSETS_FOLDER}${product?.image}`}>
      <ProductDetailDiv product={product}>
      { isMobile && 
      <HeaderMobile onClose={() => onClose()}>
        <StyledClose><GrClose /></StyledClose>
        {product?.external !== undefined && (
          <StyledButton onClick={() => onClickKnowMore()}>
              <Text
                fontFamily="Amorim Sans Book"
                fontSize="14px"
                textId="product-detail.know-more"
              />
          </StyledButton>
        )}
      </HeaderMobile>
      }
          <SpecificationsComponent product={product} />
          <DescriptionComponent subTitle={collection?.name} 
                                title={product?.reference} 
                                sku={product?.sku}/>
          <FooterComponent knowLLink={() => onClickKnowMore()} showKnowLink={product?.external !== undefined} product={product} />
      </ProductDetailDiv>
    </ContainerBackground>
  )
};

export default ProductDetailComponent;
